export enum PlayerFootEnum {
  Left = "left",
  Right = "right",
  Both = "both",
}
